
import { getShop } from "../common/pageData";
import { sleep } from "../common/time";
import { ShopExcludedForClearingCart } from "../features/constants";
import { mrOrderIDAttributionKey } from "./CSVUpload/constants";


export const clearCart = async () => {
    const clearCartUrl = `/cart/clear.js`;
    const shopUrl = getShop();
    const shouldClearCart = shopUrl && !ShopExcludedForClearingCart.includes(shopUrl);
    if (!shouldClearCart) {
        console.log('Skipping cart clearing for shop:', shopUrl);
        return;
    }
    // Clear the cart
    await fetch(clearCartUrl, {
        method: 'GET',
    });
}

export const addItemsToCart = async (items) => {
    // add maximum of 100 items in one api call
    const chunkSize = 100;
    const chunkedItems = [];
    for (let i = 0; i < items.length; i += chunkSize) {
        chunkedItems.push(items.slice(i, i + chunkSize));
    }
    let error = '';

    for (let i = 0; i < chunkedItems.length; i++) {
        const res = await fetch(`/cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items: chunkedItems[i] }),
        });
        
        if (!res.ok) {
            const data = await res.json();
            const message = data.message === 'Cart Error' ? 'Total SKUs cannot exceed 500' : 'Maximum quantity of some products in cart reached.';

            error = message;
        }
        await sleep(800);
    }

    return error && error;
}

export const addAttributesToCart = async (mrOrderID: string) => {
    const attributes = {
        attributes: {
            [mrOrderIDAttributionKey]: mrOrderID,
        },
    };

    await fetch(`/cart/update.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(attributes),
    });
};

export const getValues = (url: string) => {
    return url.split('&').map(str => str.split('=')[1]);
}